import { useEffect, useContext, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";

import GenericListContainer from "../GenericList/GenericListContainer";
import {
  GET_HISTORICAL_ORGANIZATION_VERSIONS,
  GET_LOGIN_DATA,
  GET_ORG_VERSION,
} from "../GraphQl/query";
import { ProjectContext } from "../ProjectProvider";
import {
  getAdditionalColumns,
  getProjectList,
  getHistoryColumn,
  getVariables,
} from "./functions";
import { PageWrapper } from "../PageWrapper/PageWrapper";
import { isClonedColumn, statusColumn } from "../Helpers/structureConstants";
import {
  getClonedCell,
  getLeftAlignCell,
} from "../Helpers/GenericListHelpers/genericListElements";
import { ADMIN, FILTER_TYPES, MOH } from "../Helpers/constants";
import AlertComponent from "../ModelItemsForm/AlertComponent";

const ProjectList = () => {
  const { setProject, setProjectData } = useContext(ProjectContext);

  const navigate = useNavigate();
  useEffect(
    () => {
      setProject("");
      setProjectData(null);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const { t } = useTranslation();

  const { state, search } = useLocation();
  const params = useParams();
  const { structureId, year } = params;
  const { refetch, prj_desc } = state || {};
  const code = state?.code ? state.code : params?.code;
  const queryParams = new URLSearchParams(search);
  const projectVersionId = queryParams.get("projectId");

  const [alertMessage, setAlertMessage] = useState("");
  const [isAlertOpen, setAlertOpen] = useState(false);

  const {
    data: auth,
    loading: authLoading,
    error: authError,
  } = useQuery(GET_LOGIN_DATA);

  const query = code ? GET_HISTORICAL_ORGANIZATION_VERSIONS : GET_ORG_VERSION;
  const variables = code ? { prjId: projectVersionId } : { structureId, year };

  const {
    data: list,
    loading: listLoading,
    error: listError,
  } = useQuery(query, {
    variables,
    fetchPolicy: refetch ? "network-only" : "cache-first",
    skip: !auth, // Prevents running before auth data is available
  });

  const role = auth ? auth.userInfo.role : "";

  const projectList = list
    ? getProjectList(list, role).sort((a, b) => b.orgVersionId - a.orgVersionId)
    : [];

  const parentIds = new Set(
    projectList.map((item) => item.parent).filter((id) => id !== null),
  );

  const updatedItems = projectList.map((item) => ({
    ...item,
    isParent: parentIds.has(item.orgVersionId),
  }));

  const instCode = getVariables(auth);

  const primaryColumns = [
    {
      ...statusColumn,
      filterFn: "statusFilterFunction",
      filterVariant: FILTER_TYPES.orgStatusFilter,
      Cell: (row) => getLeftAlignCell(row),
    },
    { ...isClonedColumn, Cell: (row) => getClonedCell(row) },
  ];
  const additionalColumns = getAdditionalColumns(t, navigate, setProjectData);

  if ([MOH, ADMIN].includes(role)) {
    additionalColumns.push(getHistoryColumn(t, navigate));
  }
  console.log("Project List alertMessage", alertMessage);
  return (
    <PageWrapper
      loading={authLoading || listLoading}
      error={authError || listError}
    >
      {isAlertOpen && (
        <AlertComponent
          color={"danger"}
          isAlertOpen={isAlertOpen}
          message={alertMessage}
          toggleAlert={setAlertOpen}
        />
      )}
      <GenericListContainer
        setAlertMessage={setAlertMessage}
        setAlertOpen={setAlertOpen}
        primaryColumns={primaryColumns}
        additionalColumns={additionalColumns}
        list={updatedItems}
        structureName={"Project"}
        btnLabel={"Create Project"}
        parentValue={"Progetti"}
        code={code}
        instCode={instCode}
        prj_desc={prj_desc}
      />
    </PageWrapper>
  );
};

export default ProjectList;
